/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Custom_Pages_Edit_NameInputs */

const en_forms_custom_pages_edit_name = /** @type {(inputs: Forms_Custom_Pages_Edit_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

const de_forms_custom_pages_edit_name = /** @type {(inputs: Forms_Custom_Pages_Edit_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

/**
* | output |
* | --- |
* | "Name" |
*
* @param {Forms_Custom_Pages_Edit_NameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_custom_pages_edit_name = /** @type {((inputs?: Forms_Custom_Pages_Edit_NameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Custom_Pages_Edit_NameInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_custom_pages_edit_name(inputs)
	return de_forms_custom_pages_edit_name(inputs)
});